module.exports = __webpack_public_path__ + "img/110.d0374814.jpg";